<style lang="scss"></style>

<template>
  <div class="container-fluid management">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
